module.exports = __webpack_public_path__ + "img/1737080394412-Screenshot 97.png.6bd9cd59.webp";